import { createContext } from 'react';

export interface IInboxContext {
  inbox: any[];
  setInbox: any;
}

export const InboxContext = createContext({} as IInboxContext);
